import { render } from "./SponsorsPage.vue?vue&type=template&id=69f05dba&scoped=true&ts=true"
import script from "./SponsorsPage.vue?vue&type=script&lang=ts"
export * from "./SponsorsPage.vue?vue&type=script&lang=ts"

import "./SponsorsPage.vue?vue&type=style&index=0&id=69f05dba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f05dba"]])

export default __exports__